/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandMastercard = createReactComponent("brand-mastercard", "IconBrandMastercard", [
  ["path", { d: "M14 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M12 9.765a3 3 0 1 0 0 4.47", key: "svg-1" }],
  [
    "path",
    {
      d: "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-2"
    }
  ]
]);

export { IconBrandMastercard as default };
//# sourceMappingURL=IconBrandMastercard.js.map
